import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana31Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1468_40152)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))}
      d="M484.459 323.788L619.075 266.096L623.883 323.788L503.69 371.866L484.459 323.788Z" 
      fill={getFillByLot(6, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))}
      d="M364.264 367.063L484.457 323.794L503.688 371.871L390.706 417.545L364.264 367.063Z" 
      fill={getFillByLot(7, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))}
      d="M628.685 381.487L623.878 323.794L503.685 371.871L530.127 424.756L628.685 381.487Z" 
      fill={getFillByLot(5, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))}
      d="M426.761 470.426L390.703 417.541L503.685 371.867L530.127 424.752L426.761 470.426Z" 
      fill={getFillByLot(8, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))}
      d="M635.904 456.002L628.692 381.482L530.134 424.752L556.576 487.252L635.904 456.002Z" 
      fill={getFillByLot(4, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))}
      d="M467.622 530.523L426.756 470.426L530.122 424.753L556.564 487.253L467.622 530.523Z" 
      fill={getFillByLot(9, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))}
      d="M645.516 549.754L635.9 456.003L549.361 489.657L587.823 573.792L645.516 549.754Z" 
      fill={getFillByLot(3, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))}
      d="M522.91 602.639L467.621 530.523L549.352 489.657L587.814 573.792L522.91 602.639Z" 
      fill={getFillByLot(10, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))}
      d="M563.788 653.117L522.922 602.636L645.519 549.751L652.73 614.655L563.788 653.117Z" 
      fill={getFillByLot(2, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M662.345 718.021L652.729 614.655L563.786 653.117L635.902 734.848C657.056 744.464 662.345 727.637 662.345 718.021Z" 
      fill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
  <defs>
    <pattern id="pattern0_1468_40152" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1468_40152" transform="matrix(0.0032973 0 0 0.00437134 -5.92297 -2.20727)"/>
    </pattern>
    <image id="image0_1468_40152" width="4096" height="2304" href="/mz2.png"/>
  </defs>
</svg>

  );
};